import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
//const
import { QUERY_KEYS } from 'consts/queryKeys';

//custom hooks
import { useCustomToast } from 'hooks';
//services
import { updateReservationStatus } from 'modules/accommodations/features/reservations/api';

export const useMutationChangeStatusModal = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  // Set unit attributes
  const { mutate: setReservationStatus, isLoading } = useMutation(updateReservationStatus, {
    onSettled: () =>
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_TYPE, { refetchInactive: true }),
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS, { refetchInactive: true });
      successToast(t('Reservation status is successfully updated'));
    },
    onError: () => errorToast(),
  });

  return {
    isLoading,
    setReservationStatus,
  };
};
